import { useQuery } from '@tanstack/react-query'
import { fetchPackages, fetchPackageById } from '../api/packages'

const FALLBACK_PACKAGES = [
  {
    id: 1,
    slug: 'small-celebration',
    title: 'Small Celebration',
    subtitle: 'Perfect for intimate gatherings',
    price: 15000,
    currency: 'EGP',
    max_guests: 20,
    duration_hours: 3,
    badge: '',
    color_accent: '#FF6BB5',
    is_featured: false,
    order: 1,
    features: [
      "Printed banner with child's name",
      'Colorful balloons (50)',
      'Cartoon characters (2)',
      'Printed T-shirt for child',
      'Deluxe gift box for child',
      'Gifts & toys for guests',
      'Printed cake 2kg',
      'DJ & Music',
      'Tele-match games',
      'Puppet show',
      'Magician show',
    ],
  },
  {
    id: 2,
    slug: 'medium-celebration',
    title: 'Medium Celebration',
    subtitle: 'Our most popular choice',
    price: 30000,
    currency: 'EGP',
    max_guests: 35,
    duration_hours: 4,
    badge: 'Most Popular',
    color_accent: '#7C3AFF',
    is_featured: true,
    order: 2,
    features: [
      'All Small Celebration features',
      'Colorful balloons (100)',
      'Cartoon characters (3)',
      'Professional DJ with sound system',
      'Interactive tele-match games',
      'Printed cake 3kg',
      'Photography (50 photos)',
      'Puppet show',
      'Magician show',
    ],
  },
  {
    id: 3,
    slug: 'premium-experience',
    title: 'Premium Experience',
    subtitle: 'The ultimate celebration',
    price: 50000,
    currency: 'EGP',
    max_guests: 50,
    duration_hours: 5,
    badge: '',
    color_accent: '#FFC300',
    is_featured: false,
    order: 3,
    features: [
      'All Medium Celebration features',
      'Colorful balloons (150)',
      'Cartoon characters (4)',
      'Professional puppet theater show',
      'Magician show with magic tricks',
      'Printed cake 5kg + mini cakes',
      'Photography + Video',
      'Photo booth corner with props',
      'VIP gifts for child',
    ],
  },
]

export function usePackages() {
  const query = useQuery({
    queryKey: ['packages'],
    queryFn: fetchPackages,
    staleTime: 5 * 60 * 1000,
    retry: 1,
    placeholderData: FALLBACK_PACKAGES,
  })

  return {
    ...query,
    data: query.data ?? FALLBACK_PACKAGES,
  }
}

export function usePackage(id) {
  return useQuery({
    queryKey: ['packages', id],
    queryFn: () => fetchPackageById(id),
    staleTime: 5 * 60 * 1000,
    enabled: Boolean(id),
  })
}

export { FALLBACK_PACKAGES }
